module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "cube-image-preview-fade"
    }
  }, [_c('cube-popup', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVisible),
      expression: "isVisible"
    }],
    attrs: {
      "type": "image-preview",
      "z-index": _vm.zIndex,
      "center": false
    }
  }, [_c('div', {
    staticClass: "cube-image-preview-container"
  }, [_c('div', {
    staticClass: "cube-image-preview-header"
  }, [_vm._t("header", null, {
    current: _vm.currentPageIndex
  })], 2), (_vm.isVisible) ? _c('cube-slide', {
    ref: "slide",
    attrs: {
      "data": _vm.imgs,
      "initial-index": _vm.currentPageIndex,
      "auto-play": false,
      "loop": _vm.loop,
      "speed": _vm.speed,
      "options": _vm.options
    },
    on: {
      "change": _vm.slideChangeHandler
    }
  }, [_vm._l((_vm.imgs), function(img, index) {
    return _c('cube-slide-item', {
      key: index
    }, [_c('div', {
      staticClass: "cube-image-preview-item",
      on: {
        "click": _vm.itemClickHandler
      }
    }, [_c('cube-scroll', {
      ref: "items",
      refInFor: true,
      attrs: {
        "options": _vm.scrollOptions
      },
      nativeOn: {
        "dblclick": function($event) {
          _vm.dblclickHandler(index, $event)
        }
      }
    }, [_c('img', {
      staticClass: "cube-image-preview-img",
      attrs: {
        "src": img
      },
      on: {
        "load": function($event) {
          _vm.imgLoad(index)
        }
      }
    })])], 1)])
  }), _c('template', {
    slot: "dots"
  }, [_c('i')])], 2) : _vm._e(), _c('div', {
    staticClass: "cube-image-preview-footer"
  }, [_vm._t("footer", [_c('span', {
    staticClass: "cube-image-preview-counter"
  }, [_vm._v(_vm._s(_vm.currentPageIndex + 1) + "/" + _vm._s(_vm.imgs.length))])], {
    current: _vm.currentPageIndex
  })], 2)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-050c4d73","hasScoped":false,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/image-preview/src/image-preview.vue
// module id = 359
// module chunks = 0